module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_09.dot-be50c83f2e70f5d9a27b9f3e865a4de1.svg";